'use client'

import {observer} from 'mobx-react'
import * as UI from '../footer.styled'
import {menuTitles} from '../footer.types'
import React from 'react'
import {useLayoutStore} from '@/src/shared/ui/layout'
import {formatPageLink} from '@/src/core/domain/page/page-link-url'
import {NextLink} from '@/src/shared/ui/next-link'

interface FooterMenuProps {
  readonly menu: LayoutData['footer']['menu']
}

export const FooterMenu: React.FC<FooterMenuProps> = observer(({menu}) => {
  const layoutStore = useLayoutStore()
  const menuKeys = Object.keys(menu) as Array<keyof typeof menu>

  return (
    <>
      {menuKeys.map(menuCode => (
        <UI.NavColumn key={menuCode}>
          {menuTitles[menuCode] && <UI.ColumnTitle>{menuTitles[menuCode]}</UI.ColumnTitle>}

          {(menu[menuCode] ?? []).map((link, i) => (
            <UI.Link
              as={NextLink}
              key={i}
              href={formatPageLink(link.url, layoutStore.data.static_pages)}>
              {link.title}
            </UI.Link>
          ))}
        </UI.NavColumn>
      ))}
    </>
  )
})
